var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "", "align-center": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "mb-2", staticStyle: { width: "30px" } },
        _vm._l(_vm.masks, function(mask, index) {
          return _c(
            "v-card",
            {
              key: mask.label,
              staticClass: "pa-2 btn",
              class: { selected: index === _vm.selectedMaskIndex },
              on: {
                click: function($event) {
                  return _vm.selectMask(index)
                }
              }
            },
            [
              _c("span", { staticClass: "font-weight-black" }, [
                _vm._v(_vm._s(mask.mk_label))
              ])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22df5d94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22df5d94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskManagement.vue
// module id = null
// module chunks = 